export function shouldShowPropertyListExport(propertyCount: number): boolean {
  return propertyCount > 0
}

/** Session/API may still carry a single string from the old text filter. */
export function normalizePmsPropertyCodes(value: unknown): string[] | undefined {
  if (Array.isArray(value)) {
    const codes = value.map((item) => String(item).trim()).filter(Boolean)
    return codes.length > 0 ? codes : undefined
  }
  if (typeof value === 'string' && value.trim()) {
    return [value.trim()]
  }
  return undefined
}
